// StubMenu.tsx — ONE control where the fleet has two circles.
//
// 🔴 IDENTITY (2026-08-30): "wordmark-left + two-circular-controls-right" is one of the four
// banned fleet fingerprints. Encore lost the "🎟 Encore" wordmark entirely (the most recent
// night is the header now), and the two round menu buttons collapse here into a single control
// drawn in this app's own material — a punched stub tab: square, with the dashed perforation and
// the two punched notches the ledger's stubs already use. Deliberately not a third circle, and
// deliberately not Garage's dial, Interior's viewfinder or Round Card's scorecard cell.
//
// The shared BackupMenu / AccountMenu are rendered UNCHANGED inside — the account-deletion flow
// the store gate depends on lives inside AccountMenu and must not be reimplemented here.

import { useState, type ReactNode } from "react";
import { platform } from "./tauri-web";
import { WalletTopUp } from "./iap";

export function StubMenu({ backup, account }: { backup: ReactNode; account: ReactNode }) {
  const [open, setOpen] = useState(false);
  // Apple 2.1(b) (Focus/Gifted rejections, 2026-09-05): the wallet top-up must be visible
  // the moment this drawer opens, not nested one tap deeper inside AccountMenu's own avatar
  // popover. Rendered directly here, gated iOS/MAS same as AccountMenu's own gate.
  const isIos = platform() === "ios";
  const isMasMac = platform() === "macos" && (import.meta as any).env?.VITE_MAS === "1";
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="oen-stubmenu"
        aria-label="Settings, backup and account"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="3.1" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 3.7v2.2M12 18.1v2.2M3.7 12h2.2M18.1 12h2.2M6.2 6.2l1.5 1.5M16.3 16.3l1.5 1.5M17.8 6.2l-1.5 1.5M7.7 16.3l-1.5 1.5"
                stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div className="oen-menu-panel">
            {(isIos || isMasMac) && (
              <>
                <div style={{ padding: "0.5rem 0.5rem 0.15rem" }}><WalletTopUp /></div>
                <div className="oen-menu-rule" />
              </>
            )}
            <div className="oen-menu-row">{backup}<span>Back up &amp; restore</span></div>
            <div className="oen-menu-rule" />
            <div className="oen-menu-row">{account}<span>Account</span></div>
          </div>
        </>
      )}
    </div>
  );
}
